import nodeClient from "./node-client";

export const saveCustomer = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/patient/add`,
    payload
  );
  return response.data;
};

export const getCustomerList = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/patient/patientList`,
    payload
  );
  return response.data;
};

export const searchPatients = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/patient/patientFilteredList?${encodeURI(query)}`
  );
  return response?.data;
};

export const getCustomerDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/patient/find?${encodeURI(query)}`
  );
  return response?.data;
};

export const getPrimaryCustomerList = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/patient/getParentPatientList?${encodeURI(query)}`
  );
  return response?.data;
};
